import devLog from './devLog';
/**
 * ============================================================================
 * V31.2.1 DYNAMIC URL RESOLVER - Production Ready with Host Detection
 * ============================================================================
 * Uses environment variables and dynamic origin detection
 * Compatible with all deployment environments (preview, production, local)
 * V31.2.1: STRICTLY BLOCK INTERNAL CLUSTER URLS
 */

// Get backend URL dynamically
export const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    const currentOrigin = window.location.origin;
    
    // V31.2.0: PRODUCTION FIX - If we're on production domain, use it directly
    if (currentHost === 'app.elonprompt.ai' || currentHost === 'elonprompt.ai') {
      return `https://${currentHost}`;
    }
    
    // First priority: Environment variable (set at build time)
    let envUrl = process.env.REACT_APP_BACKEND_URL;
    
    // V31.2.1: NUCLEAR BLOCK for internal cluster URLs
    if (envUrl && (
      envUrl.includes('emergentcf.cloud') || 
      envUrl.includes('cluster-9') || 
      envUrl.includes('login-repair')
    )) {
      devLog.warn('[V31.2.1] Internal Cluster URL detected and blocked. Falling back to current origin.');
      return currentOrigin;
    }
    
    // V31.2.0: Check for host mismatch - envUrl points to emergent.host but we're not on emergent.host
    if (envUrl && envUrl.includes('emergent.host') && !currentHost.includes('emergent.host')) {
      return currentOrigin;
    }
    
    if (envUrl) {
      return envUrl;
    }
    
    // Fallback: Use current origin (works for all deployments)
    return currentOrigin;
  }
  
  // Server-side fallback
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (envUrl && (envUrl.includes('emergentcf.cloud') || envUrl.includes('cluster-9'))) {
    return 'https://app.elonprompt.ai';
  }
  return envUrl;
};

export const getApiUrl = (endpoint = '') => {
  const base = getBackendUrl();
  return `${base}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
};

export const sanitizeUrl = (url) => url;

// V31.2.0: Make BACKEND_URL a getter so it's always dynamic
let _cachedBackendUrl = null;
export const BACKEND_URL = (() => {
  if (typeof window !== 'undefined') {
    // Re-evaluate on each access to handle navigation
    return getBackendUrl();
  }
  if (!_cachedBackendUrl) {
    _cachedBackendUrl = getBackendUrl();
  }
  return _cachedBackendUrl;
})();

export default getBackendUrl;

// Log on load
if (typeof window !== 'undefined') {
  devLog.log('[V31.2.1] Backend URL:', getBackendUrl());
}
